import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';

export const useStyles = makeStyles((theme) => ({
    addWidgetButton: {
        position: 'absolute',
        right: theme.spacing(4),
        bottom: theme.spacing(4),
        zIndex: 1,

        '& svg': {
            height: theme.spacing(4),
            width: theme.spacing(4),
        },
    },
    autoSwitch: {
        marginLeft: 0,
    },
    avatar: {
        background: theme.palette.neutral[200],
        cursor: 'pointer',
        // border: `3px solid ${theme.palette.utility.neutralv5[50]}`,
        color: theme.palette.text.primary,
        height: theme.spacing(6),
        width: theme.spacing(6),
    },
    appBar: {
        position: 'relative',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.neutral[50],
        padding: theme.spacing(3),
        boxShadow: `2px 2px 6px rgba(0, 0, 0, 0.35)`,
        height: '68px',
        width: '100%',
        borderRadius: theme.dimensions.borderRadiusPanel,

        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            width: `calc(100vw - ${theme.spacing(8)}px)`,
        },
    },
    bar: {
        /*marginRight: theme.spacing(4),*/
        height: '100%',
    },
    badge: {
        alignItems: 'center',
        marginLeft: '12px',
        zIndex: 0,
        /*width: '100%',*/
        '& span': {
            top: '-5px',
            backgroundColor: theme.palette.secondary.main,
        },
    },
    buttonWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '16px',
        position: 'absolute',
        top: '-12px',
        right: theme.spacing(-10),
    },
    divider: {
        margin: theme.spacing(0, 1),
    },
    dropDownOption: {
        padding: '8px',
        cursor: 'pointer',
        fontSize: '14px',

        '&:hover': {
            color: theme.palette.secondary.main,
        },
    },
    fakeButton: {
        width: '12px',
        height: '12px',
        overflow: 'visible',
        transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
    },
    globalHeader__menuWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
    },
    headerButton: {
        padding: theme.spacing(1.5),
        marginLeft: '8px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 'fit-content',
        borderRadius: '5px',

        '&:hover': {
            boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.35)',
        },
    },
    header__menuWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        backgroundColor: 'transparent',
        '&:hover': {
            color: theme.palette.secondary.main,
            backgroundColor: 'transparent',
        },
    },
    languageSwitcher: {
        width: '100%',
        padding: '0 16px',

        '& .MuiInput-underline:before': {
            borderRadius: '5px',
        },
        '& .MuiInput-root': {
            background: theme.palette.background.neutral,
            padding: theme.spacing(1, 2),
            borderRadius: '5px',
            height: theme.spacing(4),
            fontSize: theme.typography.size.m,

            '& .MuiSelect-icon': {
                top: 'auto',
            },
        },
    },
    lh1: {
        lineHeight: 1,
    },
    menuItems: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,

        '&:hover': {
            backgroundColor: theme.palette.background.default,
        },
    },
    menu__chevron: {
        height: theme.spacing(3),
        fontSize: '24px',
        cursor: 'pointer',
    },
    menu__wrapper: {
        background: theme.palette.background.default,
        width: '236px',
    },
    '& .MuiTooltip-popper': {
        height: 'fit-content',
    },
    root: {
        flexGrow: 1,
    },
    searchAdornment: {
        marginLeft: '8px',
        cursor: 'pointer',
    },
    stageTitle: {
        fontSize: '14px',
        overflow: 'hidden',
        maxWidth: '150px',
        textOverflow: 'ellipsis',
        /*width: '100%',*/
        whiteSpace: 'nowrap',
    },
    tab: {
        '&:hover': {
            '& $tabButton': {
                opacity: '1',
            },
        },
    },
    tabButton: {
        display: 'flex',
        opacity: '0',
        transition: 'transform 0.5s, opacity 0.5s',
    },
    tooltip: {
        display: 'flex',
        flexWrap: 'nowrap',
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.s,

        '& .MuiTooltip-arrow': {
            top: `${theme.spacing(1)}px !important`,
            marginTop: `0 !important`,

            '&:before': {
                background: theme.palette.neutral[100],
            },
        },
    },
    wholeTab: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        /*width: '90%',*/
    },
    searchIcon: {
        margin: '0 8px',
        minHeight: '30px',
        height: '30px',
        width: '30px',
    },
    stageFilterInput: {
        marginLeft: theme.spacing(1),

        ' & input': {
            padding: theme.spacing(1.8),
        },
    },
    slideIn: {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        transform: 'translateY(0)',
        transition: 'transform 0.3s ease-in-out',
    },
    slideOut: {
        display: 'none',
        transform: 'translateY(-100%)',
        transition: 'transform 0.3s ease-in-out',
    },
    themeToggleHeadline: {
        fontSize: theme.typography.size.m,
        marginTop: theme.spacing(1),
    },
}));
